// Single source of truth: bounceflow-prd-specmap.json at the repo root.
// All branding, name mapping, node exclusions, and progress reset are baked
// into the JSON itself. This module is a thin typed pass-through.

import rawSpecMap from '../../../bounceflow-prd-specmap.json';
import type {
  ActivityItem,
  CommentData,
  LaneData,
  NodeData,
  SpecMapData,
  SpecMapVersion,
} from '@/lib/specmap/types';

export const BRAND_PLATFORM_NAME = 'fern';
export const BRAND_CLIENT_NAME = 'bouncemelb';

export const TEAM_ROSTER = {
  techLead: { name: 'Kavinu Wethmin', role: 'Tech Lead', initials: 'KW', color: '#0F9B8E' },
  engineer1: { name: 'Praveesh Ranuga', role: 'Engineer', initials: 'PR', color: '#3B82F6' },
  engineer2: { name: 'Thenu Sandul', role: 'Engineer', initials: 'TS', color: '#A78BFA' },
  projectManager: { name: 'Shenuka Dias', role: 'Project Manager', initials: 'SD', color: '#F59E0B' },
} as const;

export const SPEC_MAP_NODES: NodeData[] = rawSpecMap.nodes.map((node) => ({
  ...node,
  archivedAt: node.archivedAt ?? null,
  activity: node.activity.map((event) => ({
    ...event,
    type: event.type as ActivityItem['type'],
  })),
}));

export const SPEC_MAP_LANES: LaneData[] = rawSpecMap.lanes.map((lane) => ({ ...lane }));

export const SPEC_MAP_VERSIONS: SpecMapVersion[] = rawSpecMap.versions.map((version) => ({
  ...version,
}));

export const SPEC_MAP_COMMENTS: CommentData[] = rawSpecMap.comments.map((comment) => ({
  ...comment,
}));

export const SPEC_MAP_METADATA: SpecMapData = {
  ...rawSpecMap.specMap,
  logoUrl: rawSpecMap.specMap.logoUrl ?? null,
};
